/**
 * @generated SignedSource<<d2a75a2b58839ff125101acb655fe8aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesOrderUpdateInput = {
  externalRef?: string | null;
  accountId?: string | null;
  userId?: string | null;
  customerEmail?: string | null;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  subAmount?: number | null;
  taxAmount?: number | null;
  totalAmount?: number | null;
  discountAmount?: number | null;
  grandAmount?: number | null;
  currencyCode?: string | null;
  status?: string | null;
  meta?: any | null;
  paymentTerms?: any | null;
  eventRecurringId?: string | null;
  accountInvoiceId?: string | null;
  type?: string | null;
  updatedBy?: string | null;
  contactId?: string | null;
  eventGuestId?: string | null;
  eventRequestId?: string | null;
  paymentId?: string | null;
};
export type salesOrderUpdateMutation$variables = {
  id: string;
  input: SalesOrderUpdateInput;
};
export type salesOrderUpdateMutation$data = {
  readonly updateSalesOrder: {
    readonly salesOrder: {
      readonly " $fragmentSpreads": FragmentRefs<"salesOrderFragment">;
    };
  };
};
export type salesOrderUpdateMutation = {
  variables: salesOrderUpdateMutation$variables;
  response: salesOrderUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesOrderUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SalesOrderPayload",
        "kind": "LinkedField",
        "name": "updateSalesOrder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesOrder",
            "kind": "LinkedField",
            "name": "salesOrder",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "salesOrderFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesOrderUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SalesOrderPayload",
        "kind": "LinkedField",
        "name": "updateSalesOrder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesOrder",
            "kind": "LinkedField",
            "name": "salesOrder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerFirstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerLastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventRecurringId",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discountAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grandAmount",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentTerms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentIn",
                "kind": "LinkedField",
                "name": "paymentIns",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "payerEmail",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrder",
                    "kind": "LinkedField",
                    "name": "salesOrder",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderItem",
                "kind": "LinkedField",
                "name": "salesOrderItems",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "quantity",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "discount",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0eeff52e5f764503f51df1bb4dcf8552",
    "id": null,
    "metadata": {},
    "name": "salesOrderUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation salesOrderUpdateMutation(\n  $id: ID!\n  $input: SalesOrderUpdateInput!\n) {\n  updateSalesOrder(id: $id, input: $input) {\n    salesOrder {\n      ...salesOrderFragment\n      id\n    }\n  }\n}\n\nfragment productFragment on Product {\n  id\n  externalRef\n  accountId\n  name\n  description\n  type\n  price\n  currencyCode\n  meta\n  createdAt\n}\n\nfragment salesOrderAmountFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderBaseFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderFragment on SalesOrder {\n  ...salesOrderBaseFragment\n  ...salesOrderAmountFragment\n  ...salesOrderPaymentsFragment\n  salesOrderItems {\n    ...salesOrderItemFragment\n    id\n  }\n}\n\nfragment salesOrderItemFragment on SalesOrderItem {\n  id\n  name\n  description\n  quantity\n  price\n  discount\n  currencyCode\n  meta\n  product {\n    ...productFragment\n    id\n  }\n}\n\nfragment salesOrderPaymentsFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d40ce33ac87274bec769fb5e33fcfd15";

export default node;
